export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const SAVE_PROFILE = "SAVE_PROFILE";
export const LOGOUT = "LOGOUT";
export const UPDATETOKEN = "UPDATETOKEN";
export const UPDATETOKEN_SUCCESS = "UPDATETOKEN_SUCCESS"
export const UPDATETOKEN_ERROR = "UPDATETOKEN_ERROR"
